import React from 'react';
import { DataProviderInstance } from '../../../../api/DataProvider';
import { SendWhatsAppMessage } from '../../../../api/WhatsappAPI';
import MessagesTemplate from '../../../../consts/MessagesTemplate';
import CalendarConfig from '../../../../consts/CalendarConfig';
import PatientItem from '../shared/PatientItem';
import { ContactActions } from '../shared/IconAction';
import useSentFlag from '../../hooks/useSentFlag';

/** Paciente que cancelou e ainda não reagendou. */
function CanceledItem({ item }) {
  const { CompanyConfig } = DataProviderInstance();
  const templates = MessagesTemplate.getTemplates(CompanyConfig);
  const [sent, markSent] = useSentFlag(`canceledMsgSent-v2-${item.id}`);
  const hasPhone = item.patient_phone && item.patient_phone.length >= 8;

  const canceledDate = item.date ? CalendarConfig.GetDDMMAAAA(item.date) : '';
  const canceledTime = item.date ? CalendarConfig.GetTime(item.date) : '';
  // item.date é a data da consulta cancelada (o backend lista as de 5 dias atrás)

  function handleWhatsApp() {
    let message = templates.CanceledAppointmentFollowUp || '';
    if (!message) return;

    const firstName = item.patient_name ? item.patient_name.split(' ')[0] : 'Paciente';
    message = message.replaceAll('{name}', firstName);
    message = message.replaceAll('{company_name}', CompanyConfig?.Name || '');

    SendWhatsAppMessage(item.patient_phone, MessagesTemplate.ConvertToWhatsAppText(message), item.patient_country);
    markSent();
  }

  return (
    <PatientItem
      name={item.patient_name || 'Paciente'}
      patientId={item.patient}
      tone="red"
      sent={sent}
      meta={canceledDate ? `Cancelou a consulta de ${canceledDate}${canceledTime ? ` às ${canceledTime}` : ''}` : null}
      actions={hasPhone && (
        <ContactActions whatsappTitle="Convidar para reagendar" onWhatsApp={handleWhatsApp} phone={item.patient_phone} />
      )}
    />
  );
}

export default CanceledItem;
